import React from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_SOURCE_HOUSEHOLD_NOTES,
  DATA_TABLE_VIEW_ID_HOUSEHOLD_NOTES_ALL,
} from 'common/dataTableConstants';

import SrCreateNoteForm from 'client/components/SrCreateNoteForm';
import SrDarkModal from 'client/components/SrDarkModal';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrNotesList, {
  SR_HOUSEHOLD_NOTES,
} from 'client/components/SrNotesList';

const SrHouseholdNotesModal = ({
  householdId,
  dispatch,
  currentUser,
  onClose,
  onUpdate,
}) => {
  return (
    <SrDarkModal onClose={onClose}>
      <div className='adminModal'>
        <div
          className='householdNotes'
          onClick={(event) => event.stopPropagation()}
        >
          <SrText weight='bolder' size='larger'>
            NOTES
          </SrText>
          <SrBox marginTop='20px' />
          <SrDataTableConnected
            itemsPropName='notes'
            dataSource={DATA_TABLE_SOURCE_HOUSEHOLD_NOTES}
            rootViewId={DATA_TABLE_VIEW_ID_HOUSEHOLD_NOTES_ALL}
            initialViewSettings={{
              sort: {
                createdDate: 'desc',
              },
              filter: {
                householdId,
              },
            }}
          >
            {({ notes, reloadItems, dataTableApiState, onInfiniteScrollWrapperRef }) => (
              <>
                <div ref={onInfiniteScrollWrapperRef}>
                  <SrNotesList
                    type={SR_HOUSEHOLD_NOTES}
                    openedInModal
                    notes={notes}
                    dispatch={dispatch}
                    reloadDataTable={(noteId) => {
                      reloadItems({
                        count: 1,
                        filter: { 'householdNotes.id': noteId },
                      });

                      if (onUpdate) {
                        onUpdate();
                      }
                    }}
                    currentUser={currentUser}
                  />
                </div>
                {dataTableApiState.inProgress && (
                  <SrFlex justify='center'>
                    <SrText font='greycliff'>Loading ...</SrText>
                  </SrFlex>
                )}
                <SrCreateNoteForm
                  householdId={householdId}
                  dispatch={dispatch}
                  reloadDataTable={(noteId) => {
                    reloadItems({
                      count: 1,
                      filter: { 'householdNotes.id': noteId },
                    });

                    if (onUpdate) {
                      onUpdate();
                    }
                  }}
                />
              </>
            )}
          </SrDataTableConnected>
        </div>
      </div>
    </SrDarkModal>
  );
};

SrHouseholdNotesModal.propTypes = {
  householdId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func,
};

SrHouseholdNotesModal.displayName = 'SrHouseholdNotesModal';

export default SrHouseholdNotesModal;
